import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportClientsToExcel = (clients) => {
  // Format data for Excel
  const formattedData = clients.map((client, index) => ({
    No: index + 1,
    Name: client.name,
    Email: client.email,
    Phone: client.phoneNumber || "",
    Gender: client.gender || "",
    Status: client.status,
    AddreseOne: `${client.address?.line1 || ""}`,
    AddressTwo: `${client.address?.line2 || ""}`,
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Save file
  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, `clients_${Date.now()}.xlsx`);
};
